import React from 'react'
import Chip from '@mui/material/Chip'

import { getStatusLabel } from './posTaskListHelpers'

const normalizeStatus = (status) => String(status || 'default').toLowerCase()

export default function PosTaskStatusChip({ status, className = '' }) {
  const normalizedStatus = normalizeStatus(status)
  const resolvedClassName = [
    'pos-task-status',
    `pos-task-status--${normalizedStatus}`,
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Chip
      className={resolvedClassName}
      label={String(getStatusLabel(status)).toUpperCase()}
      size="small"
    />
  )
}
